(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.stockholm-living.controller.debt-financing
  (:require
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]))

(defn debt-financing
  [{:keys [report-data] :as props}]
  {:debt-financing-text      (report-ctl/rich-content props :debt-financing-text)
   :portfolio-debt-financing (report-ctl/with-footnote
                              props
                              :debt-financing-table-footnotes
                              (:portfolio-debt-financing report-data))})
